import colors from "assets/css/colors";

const BOX_SHADOW = "0 0 0 1px #e6e6e6, 0 4px 11px hsla(0, 0%, 0%, 0.1)";

const getColor = ({ menuIsOpen, isFocused }) => {
  if (menuIsOpen) return "transparent";
  if (isFocused) return colors.mainBlack;
  return colors.grey;
};
const getWidth = ({ menuIsOpen, isFocused }) => {
  if (menuIsOpen) return "0";
  if (isFocused) return "2px";
  return "1px";
};

export default {
  container: (styles, { isDisabled }) => ({
    ...styles,
    opacity: isDisabled && 0.25,
  }),
  control: (styles, { menuIsOpen, isFocused }) => ({
    ...styles,
    position: "relative",
    minHeight: 25,
    borderRadius: 0,
    borderWidth: 0,
    backgroundColor: "transparent",
    boxShadow: menuIsOpen && BOX_SHADOW,

    "&:after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      height: getWidth({ menuIsOpen, isFocused }),
      backgroundColor: getColor({ menuIsOpen, isFocused }),
    },

    "&:hover:after": {
      backgroundColor: !isFocused && colors.textGrey,
    },
  }),
  valueContainer: (styles) => ({
    ...styles,
    paddingRight: 8,
    paddingLeft: 8,
  }),
  dropdownIndicator: (styles, { selectProps: { menuIsOpen } }) => ({
    ...styles,
    lineHeight: 0,
    padding: "0 3px",
    transform: menuIsOpen && "rotate(180deg)",
  }),
  menu: (styles) => ({
    ...styles,
    margin: 0,
    borderRadius: 0,
    borderWidth: 0,
    boxShadow: BOX_SHADOW,
  }),
  menuPortal: (styles) => ({
    ...styles,
    zIndex: 10000,
  }),
  menuList: (styles) => ({
    ...styles,
    padding: 0,
  }),
  option: (styles) => ({
    ...styles,
    padding: "4px 10px",
    fontSize: 14,
    fontWeight: 400,
    lineHeight: "19.6px",
    cursor: "pointer",
    "&:not(:first-of-type)": {
      borderTop: `1px solid ${colors.strokeGrey}`,
    },
  }),
};
